import { render, staticRenderFns } from "./orderServicerTimeOut.vue?vue&type=template&id=782e2738&"
import script from "./orderServicerTimeOut.vue?vue&type=script&lang=ts&"
export * from "./orderServicerTimeOut.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports